import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=a3e11b78"
import script from "./OnboardingModal.vue?vue&type=script&lang=js"
export * from "./OnboardingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports